import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';
import { default as ActionCable } from '../../utilities/actionCable';

import './Home.scss';

import { BrandBand, ErrorModal } from '../../common/components';
import { CatalogList, Header, McMenu } from '../components/';

export class Catalogs extends Component {
  componentDidMount() {
    this.fetchCatalogs();
    this.actionCable = new ActionCable('metalMastodon', 'ecs/cable');
    this.actionCable.subscribe(
      'CatalogChannel',
      {},
      this.onReceived.bind(this)
    );
  }

  onReceived(data) {
    if (data.hasOwnProperty('catalog')) {
      // Fetch catalogs when latest status is error (cannot
      if (['error', 'complete_with_error'].includes(data.catalog.status)) {
        this.fetchCatalogs();
      } else {
        this.props.actions.receiveUpdatedCatalog(data);
      }
    }
  }

  handleDetailsClick(catalog) {
    this.props.actions.openModal('catalogErrors', catalog.status_errors || []);
  }

  fetchCatalogs() {
    const options = { ...this.props.location.query };
    this.props.actions.getCatalogs(options);
  }

  render() {
    const { catalogs } = this.props.catalogs.data;
    const { isLoading, hasLoadedOnce } = this.props.catalogs;

    return (
      <McMenu
        flags={this.props.flags}
        history={this.props.history}
        route="/distribution"
      >
        <BrandBand>
          <Header route={this.props.match} />
          <CatalogList
            actions={this.props.actions}
            catalogs={catalogs}
            isLoading={isLoading}
            hasLoadedOnce={hasLoadedOnce}
            location={this.props.location}
            onDetailsClick={this.handleDetailsClick.bind(this)}
          />
          <ErrorModal
            actions={this.props.actions}
            modals={this.props.modals}
            modalName="catalogErrors"
            title="components.ecs.catalogs.errors.title"
          />
        </BrandBand>
      </McMenu>
    );
  }
}

Catalogs.contextTypes = {
  router: PropTypes.object
};

Catalogs.propTypes = {
  actions: PropTypes.shape({
    getCatalogs: PropTypes.func,
    openModal: PropTypes.func
  }),
  catalogs: PropTypes.object.isRequired,
  flags: PropTypes.object,
  modals: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    catalogs: state.ecs.catalogs,
    flags: state.ecs.flags,
    modals: state.modals
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Catalogs);
